// @flow
import React from 'react';

import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';

const getStyles = ({ isMobile, autoScrollBodyContent }) => ({
  content: isMobile
    ? {
        position: 'absolute',
        top: 0,
        left: 0,
        transform: 'none',
      }
    : {},

  paper: isMobile
    ? {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        minHeight: '100vh',
        overflowY: 'scroll',
        WebkitOverflowScrolling: 'touch',
      }
    : {},

  closeButton: {
    position: isMobile ? 'fixed' : 'absolute',
    top: 12,
    right: 12,
    zIndex: 10,
  },
});

export default class ClosableDialog extends Dialog {
  render() {
    const {
      browser,
      contentStyle,
      bodyStyle,
      title,
      onRequestClose,
      autoScrollBodyContent,
    } = this.props;

    const isMobile = browser.lessThan.medium;
    const styles = getStyles({
      isMobile,
      autoScrollBodyContent,
    });

    return (
      <Dialog
        {...this.props}
        autoScrollBodyContent={isMobile ? false : autoScrollBodyContent}
        autoDetectWindowHeight={false}
        style={styles.root}
        contentStyle={{
          ...contentStyle,
          ...styles.content,
        }}
        bodyStyle={{
          ...bodyStyle,
          ...styles.body,
        }}
        paperProps={{ style: styles.paper }}
        title={
          <div>
            {this.props.title}
            <IconButton
              tooltip="Bezár"
              style={styles.closeButton}
              onClick={onRequestClose}
            >
              <FontIcon className="material-icons" color="black">
                close
              </FontIcon>
            </IconButton>
          </div>
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/ClosableDialog/ClosableDialog.js